import { render, staticRenderFns } from "./SignUpIntoPieces.vue?vue&type=template&id=69a4c1b9"
import script from "./SignUpIntoPieces.vue?vue&type=script&lang=js"
export * from "./SignUpIntoPieces.vue?vue&type=script&lang=js"
import style0 from "./SignUpIntoPieces.vue?vue&type=style&index=0&id=69a4c1b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports